import { roundDecimal } from '@shared/utils/math';
import { LoadingItem } from '@shared/components/loading-calculator/types';

export function getComputedProperties(items: LoadingItem[]) {
  const total: {
    totalColdPlaces: Record<string, number>;
    totalWarmPlaces: Record<string, number>;
    totalBox: number;
  } = {
    totalColdPlaces: {},
    totalWarmPlaces: {},
    totalBox: 0,
  };
  const result = items.reduce((previousValue, currentValue) => {
    const coldPlaces = currentValue.cold
      ? currentValue.cargoPlaceQuantity ?? 0
      : 0;
    const warmPlaces = currentValue.cold
      ? 0
      : currentValue.cargoPlaceQuantity ?? 0;

    const cargoPlaceName = currentValue.cargoPlaceJson.name ?? '(без типа)';

    const totalBox =
      previousValue.totalBox + (currentValue.packageQuantity ?? 0);
    return {
      totalColdPlaces: currentValue.cold
        ? {
            ...previousValue.totalColdPlaces,
            [cargoPlaceName]:
              (previousValue.totalColdPlaces[cargoPlaceName] ?? 0) + coldPlaces,
          }
        : {
            ...previousValue.totalColdPlaces,
          },
      totalWarmPlaces: !currentValue.cold
        ? {
            ...previousValue.totalWarmPlaces,
            [cargoPlaceName]:
              (previousValue.totalWarmPlaces[cargoPlaceName] ?? 0) + warmPlaces,
          }
        : {
            ...previousValue.totalWarmPlaces,
          },
      totalBox,
    };
  }, total);

  return {
    totalBox: roundDecimal(result.totalBox),
    totalColdPlaces: Object.entries(result.totalColdPlaces)
      .map(([place, quantity]) => `${roundDecimal(quantity)} ${place}`)
      .join(' / '),
    totalWarmPlaces: Object.entries(result.totalWarmPlaces)
      .map(([place, quantity]) => `${roundDecimal(quantity)} ${place}`)
      .join(' / '),
  };
}
